module.exports = __webpack_public_path__ + "media/images/OR_Logo_Black-2ef1f99eba36692484fae5941a1c29b0.svg";